module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/air-conditioner.svg?13c6da560b64ad37ee53509a5ebd292c";